import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

function SignUpForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState(''); // State for role selection
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
    return (
      password.length >= 8 &&
      hasNumber.test(password) &&
      hasSpecialChar.test(password)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (!validatePassword(password)) {
      setError(
        'Password must be at least 8 characters long, contain at least one number, and one special character.'
      );
      return;
    }
    if (!role) {
      setError('Please select a role.');
      return;
    }
    try {
      console.log('[SignUpForm/index.jsx] Request payload:', { username, password, role: role.toLowerCase() });
      // Call your signup API here
      const response = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password, role: role.toLowerCase() }), // Pass role as lowercase
      });

      if (response.ok) {
        navigate('/login'); // Redirect to login page after successful signup
      } else {
        const data = await response.json();
        setError(data.detail || 'Signup failed.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <div className="main-content">
      <div className="signup-form">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm Password"
            required
          />
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          >
            <option value="" disabled>
              Select your role
            </option>
            <option value="Student">Student</option>
            <option value="Parent">Parent</option>
            <option value="Mentor">Mentor</option>
          </select>
          {error && <p className="error">{error}</p>}
          <button type="submit">Sign Up</button>
        </form>
        <p className="password-rules">
          Password must be at least 8 characters long, contain at least one number, and one special character.
        </p>
      </div>
    </div>
  );
}

export default SignUpForm;